import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import logo from '../../imgs/logo_komity.png';
import { confirmarEntregaPublica } from '../../services/pedidosServicio';

// Página pública (sin login) a la que cae el repartidor al escanear el QR
// del ticket de despacho. No hay sesión de por medio: el token firmado en
// la URL es lo único que autoriza a cerrar ESE pedido puntual.
//
// Estados posibles:
//   - "cargando": pegándole al backend
//   - "ok": se cerró la entrega recién
//   - "ya": ya estaba cerrada de antes (se escaneó dos veces, por ej.)
//   - "error": token inválido/vencido, pedido no encontrado, o falla de red
export default function ConfirmarEntrega() {
    const { token } = useParams();
    const [estado, setEstado] = useState('cargando');
    const [mensaje, setMensaje] = useState('');
    const [displayId, setDisplayId] = useState(null);

    useEffect(() => {
        let activo = true;

        const confirmar = async () => {
            const data = await confirmarEntregaPublica(token);
            if (!activo) return;

            if (data && data.res) {
                setEstado(data.ya_entregado ? 'ya' : 'ok');
                setMensaje(data.msg || '');
                setDisplayId(data.display_id || null);
            } else {
                setEstado('error');
                setMensaje((data && data.msg) || 'No se pudo confirmar la entrega.');
            }
        };

        confirmar();
        return () => { activo = false; };
    }, [token]);

    const iconos = {
        cargando: null,
        ok: '✅',
        ya: 'ℹ️',
        error: '⚠️',
    };

    const colores = {
        ok: '#16a34a',
        ya: '#2563eb',
        error: '#dc2626',
    };

    const titulos = {
        ok: '¡Entrega confirmada!',
        ya: 'Ya estaba entregado',
        error: 'No se pudo confirmar',
    };

    return (
        <div style={{
            minHeight: '100vh',
            background: '#f8f9fa',
            fontFamily: 'system-ui, sans-serif',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '24px',
            textAlign: 'center',
        }}>
            <img src={logo} alt="Komity" style={{ height: '40px', marginBottom: '32px' }} />

            <div style={{
                background: '#fff',
                borderRadius: '16px',
                boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
                padding: '40px 28px',
                maxWidth: '380px',
                width: '100%',
            }}>
                {estado === 'cargando' ? (
                    <>
                        <div style={{
                            width: '40px',
                            height: '40px',
                            margin: '0 auto 20px',
                            border: '4px solid #e5e7eb',
                            borderTopColor: '#1a1a2e',
                            borderRadius: '50%',
                            animation: 'girar 0.8s linear infinite',
                        }} />
                        <style>{'@keyframes girar { to { transform: rotate(360deg); } }'}</style>
                        <p style={{ color: '#6b7280', fontSize: '1rem' }}>Confirmando entrega...</p>
                    </>
                ) : (
                    <>
                        <div style={{ fontSize: '3rem', marginBottom: '12px' }}>{iconos[estado]}</div>
                        <h1 style={{
                            fontWeight: 800,
                            fontSize: '1.4rem',
                            color: colores[estado],
                            marginBottom: '8px',
                        }}>
                            {titulos[estado]}
                        </h1>
                        {displayId && (
                            <p style={{ color: '#1a1a2e', fontWeight: 600, marginBottom: '4px' }}>
                                Pedido #{displayId}
                            </p>
                        )}
                        <p style={{ color: '#6b7280', fontSize: '0.95rem' }}>{mensaje}</p>
                    </>
                )}
            </div>
        </div>
    );
}
